import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  startGetRentProperties,
  startGetBuyProperties,
  startGetProperties,
} from "../../actions/properties";
import PropertyThumbnail from "./PropertyThumbnail";
import LoadingMessage from "../LoadingMessage";
import LatestProperties from "./LatestProperties";

function ListProperties(props) {
  const bussines = props.bussines;
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.property.listProperties.loading
  );
  const loadedProperties = useSelector(
    (state) => state.property.listProperties.data
  );

  useEffect(() => {
    if (bussines === "rent") {
      dispatch(startGetRentProperties());
    } else if (bussines === "buy") {
      dispatch(startGetBuyProperties());
    } else {
      dispatch(startGetProperties(props.filters));
    }
  }, [bussines]);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (
    loadedProperties !== undefined &&
    loadedProperties != null &&
    loadedProperties.length > 0
  ) {
    return (
      <section className="slice sct-color-1">
        <div className="container">
          <div className="row-wrapper">
            <div className="row">
              {loadedProperties.map((property) => (
                <PropertyThumbnail key={property.id} data={property} />
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    let bussinessDesc = "";
    if (bussines === "rent") {
      bussinessDesc = "Arrendar";
    } else if (bussines === "buy") {
      bussinessDesc = "Comprar";
    }
    return (
      <section className="slice sct-color-1">
        <div className="container">
          <div className="row-wrapper">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12 col-12"></div>
              {bussines == "" ? (
                <div>
                  <h1>No encontramos resultados, pero te podrian interesar</h1>
                  <LatestProperties></LatestProperties>
                </div>
              ) : (
                <h1>
                  Actualmente no tenenemos propiedades disponibles para{" "}
                  {bussinessDesc}
                </h1>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ListProperties;
